export default __webpack_public_path__ + "static/media/394.bffa9735.png";